import Repository from './Repository'

const resource = 'horse-shoe-task-list'

export default {
  createHorseshoeTask (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}`, data)
  },
  updateHorseshoeTask (tenantId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}`, data)
  }
}
